module.exports = __webpack_public_path__ + "asset/image/placeholder-64d4.jpg";